// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__32_-a"};